import styled from "styled-components";

export const Container = styled.div`
	display: flex;

	width: 100vw;
	height: 100vh;

	align-items: center;
	justify-content: center;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;

	width: 65vw;
	height: 90vh;

	font-family: "Mulish";

	border-radius: 0.5rem;

	gap: 5%;

	.doc-container,
	.notification-container {
		width: 100%;

		background-color: white;

		border-radius: 0.5rem;
	}

	.doc-container {
		display: flex;
		flex-direction: column;

		height: 90%;

		form {
			width: 100%;
			height: 100%;
		}

		.header {
			display: flex;

			align-items: center;
			justify-content: center;

			font-size: 1.5rem;

			gap: 1rem;

			width: 100%;
			height: 10%;

			color: #3751ff;
		}

		.edit-button {
			display: flex;

			align-items: center;

			height: 3rem;

			gap: 1rem;

			cursor: pointer;
		}

		.name-select {
			width: 20rem;
		}

		.pages {
			width: 100%;
			height: 75%;

			iframe {
				width: 100%;
				height: 100%;
			}
		}
		.buttons {
			display: flex;

			width: 100%;
			height: 15%;

			gap: 1rem;

			align-items: center;
			justify-content: space-evenly;

			box-shadow: inset 0px 1px 10px rgba(0, 0, 0, 0.25);

			button {
				width: 10rem;

				height: 3rem;

				border: none;
				border-radius: 0.25rem;

				cursor: pointer;

				text-transform: uppercase;

				font-size: 1.2rem;
				font-weight: 600;
			}
		}
	}

	#cancel-button {
		background-color: white;

		border: 1px solid #2d7bbc;

		color: #2d7bbc;
	}

	#save-button {
		width: 10rem;

		background-color: #2d7bbc;

		color: white;
	}

	.edit-docname {
		cursor: pointer;
	}

	.notification-container {
		display: flex;

		height: 25%;

		padding: 1rem;

		gap: 1rem;
	}

	.create-notification {
		display: flex;
		flex-direction: column;

		width: 25%;
		height: 100%;

		align-items: center;

		gap: 1rem;

		form {
			display: flex;
			flex-direction: column;

			width: 80%;
			height: 100%;

			gap: 0.5rem;
		}
	}

	.create-button {
		width: 100%;
		height: 3rem;

		background-color: #2d7bbc;

		border: none;
		border-radius: 0.25rem;

		font-size: 1.1rem;
		font-weight: 600;

		color: white;

		cursor: pointer;
	}

	.notification-division {
		width: 1%;

		height: 100%;

		border-right: 1px solid #c4c4c4;
	}

	.text-area {
		resize: none;

		width: 100%;
		height: 70%;

		border: 1px solid #c0c4df;
		border-radius: 0.25rem;

		padding: 0.5rem;

		font-family: "Roboto";

		::placeholder {
			color: #8c8c8c;
		}
	}

	.notification-wrapper {
		display: flex;
		flex-direction: column;

		width: 74%;

		padding: 1rem;

		align-items: center;

		overflow-x: auto;

		gap: 0.5rem;
	}

	.notification-content {
		display: flex;

		width: 100%;
		height: 85%;

		gap: 2rem;
	}

	.notification-item {
		display: flex;

		width: 14rem;

		min-width: 14rem;

		padding: 1rem;

		background: #e9e7f4;

		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

		border-radius: 0.5rem;

		position: relative;

		p {
			font-family: "Roboto";
		}
	}

	.notification-number {
		display: flex;

		width: 100%;
		height: 15%;

		font-size: 0.9rem;
		font-weight: 600;

		color: #ff0000;
	}

	.remove_notification {
		position: absolute;

		top: 0.5rem;
		right: 0.5rem;

		width: 1rem;
		height: 1rem;

		cursor: pointer;

		border: none;

		background: none;
	}

	.svg-icon {
		width: 100%;
		height: 100%;

		:hover {
			color: #ff0000;
		}
	}
`;
